const UI_TO_STORAGE_KEY = {
  $eq: "eq",
  $in: "in",
  $gt: "gt",
  $gte: "gte",
  $lt: "lt",
  $lte: "lte",
  $ne: "ne",
};

const STORAGE_TO_UI_KEY = Object.fromEntries(
  Object.entries(UI_TO_STORAGE_KEY).map(([ui, storage]) => [storage, ui])
);

const toStorageKey = (conditionType) =>
  UI_TO_STORAGE_KEY[conditionType] ?? String(conditionType ?? "").replace(/^\$/, "");

const toUiConditionType = (storageKey) => {
  if (!storageKey) return "";
  if (STORAGE_TO_UI_KEY[storageKey]) return STORAGE_TO_UI_KEY[storageKey];
  return storageKey.startsWith("$") ? storageKey : `$${storageKey}`;
};

const parseCondition = (row) => {
  if (!row.conditionType || row.conditionValue === "") return undefined;
  if (row.conditionType === "$in") {
    return {
      in: row.conditionValue.split(",").map((s) => s.trim()).filter(Boolean),
    };
  }
  if (row.conditionType === "$eq") {
    if (row.conditionValue === "true") return { eq: true };
    if (row.conditionValue === "false") return { eq: false };
  }
  const num = Number(row.conditionValue);
  if (["$gt", "$gte", "$lt", "$lte"].includes(row.conditionType) && !Number.isNaN(num)) {
    return { [toStorageKey(row.conditionType)]: num };
  }
  if (row.conditionType === "$eq" && !Number.isNaN(num) && String(row.conditionValue).trim() !== "") {
    return { eq: num };
  }
  return { [toStorageKey(row.conditionType)]: row.conditionValue };
};

const rowFromWatchField = (wf) => {
  if (!wf?.condition) return { field: wf?.field ?? "", conditionType: "", conditionValue: "" };
  const key = Object.keys(wf.condition)[0];
  const val = wf.condition[key];
  let conditionValue;
  if (Array.isArray(val)) {
    conditionValue = val.join(", ");
  } else if (val === true) {
    conditionValue = "true";
  } else if (val === false) {
    conditionValue = "false";
  } else {
    conditionValue = String(val ?? "");
  }
  return {
    field: wf.field ?? "",
    conditionType: toUiConditionType(key),
    conditionValue,
  };
};

/** Normalize legacy $-prefixed condition keys for MongoDB storage. */
export const normalizeConditionForStorage = (condition) => {
  if (!condition || typeof condition !== "object" || Array.isArray(condition)) {
    return condition;
  }
  const key = Object.keys(condition)[0];
  if (!key?.startsWith("$")) return condition;
  return { [key.slice(1)]: condition[key] };
};

export const emptyWatchFieldRow = () => ({ field: "", conditionType: "", conditionValue: "" });

export const watchFieldsToRows = (watchFields = []) =>
  watchFields.length ? watchFields.map(rowFromWatchField) : [];

export const rowsToWatchFields = (rows) =>
  rows
    .filter((r) => r.field?.trim())
    .map((r) => {
      const condition = parseCondition(r);
      return condition ? { field: r.field.trim(), condition } : { field: r.field.trim() };
    });

export const hasWatchFieldConditions = (rows = []) =>
  rows.some((row) => row.field?.trim());

export const catchAllApprovalTitle = (action) => {
  if (action === "CREATE") return "No conditions — approval required for every create";
  if (action === "DELETE") return "No conditions — approval required for every delete";
  return "No conditions — approval required for every update";
};
